var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$parent.experiment.slug},[_c('div',{staticClass:"screen-content",class:'h-' + _vm.screen.hash},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.screen.html)},on:{"click":function($event){_vm.click($event)}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }